export default {
  phoneNumber: () => "Phone number needs to be a valid format.",
  required: () => 'This is a required field.',
  txtMinLen: ({ $params }) => `Must be at least ${$params.txtMinLen.min} characters.`,
  txtMaxLen: ({ $params }) => `Must be less or equal ${$params.txtMaxLen.max} characters.`,
  email: () => 'Invalid email address.',
  emailMaxLen: ({ $params }) => `Email addresses are limited to ${$params.emailMaxLen.max} characters in length.`,
  fakeEmail: () => 'You must use a valid email address.',
  sameAsEmail: () => 'The emails don\'t match.',
  sameAsPassword: () => 'The passwords don\'t match.',
  notSameAsPassword: () => 'Username cannot be the same as password.',
  passwordPolicy: () => 'Password must be at least 12 characters long and contain at least one number and one special character.',
  noSpaces: () => 'Spaces are not allowed.',
  validCharacters: () => 'Only letters, spaces, hyphens, periods, and apostrophes are allowed.',
  fullNameMaxLength: () => 'Full name cannot exceed 30 characters. Use initials if necessary.',
}
